import React from 'react'
import { ReactComponent as ZocksLogo } from '../../../assets/images/ZocksIcon-primary.svg'
import { ProgressBar } from 'react-bootstrap'

export interface InvitationInProgressProps {
  count: number
  processed: number
}

export const InvitationInProgress = ({ count, processed }: InvitationInProgressProps) => {
  return (
    <div className='gap-3 bulk-import-container d-flex flex-column align-items-center justify-content-center p-5'>
      <div>
        <ZocksLogo width='2rem' height='2rem' />
      </div>
      <div className='zocks-loading-dot-dot-dot' />
      <div className='paragraph-large'>Sending invitations ...</div>
      You can not close this dialog while invitations are being sent.
      <ProgressBar max={count} now={processed} className='w-50' />
    </div>
  )
}
